import React from 'react';
import './style.scss';

interface Props {
    actionButtonLabel: string;
    actionButtonClick: () => void;
    dropdownLabel: string;
    children: React.ReactNode;
    disabled?: boolean;
}

const ActionButtonWithDropdownItems: React.FC<Props> = ({
    actionButtonLabel,
    actionButtonClick,
    dropdownLabel,
    children,
    disabled = false,
}: Props) => {
    return (
        <div className="btn-group action-btn-with-dropdown" role="group">
            <button
                className="btn btn-primary btn-sm font-weight-bold colored pl-3 pr-3"
                disabled={disabled}
                onClick={actionButtonClick}
                type="button"
            >
                {actionButtonLabel}
            </button>
            <div className="dropdown bordered">
                <button
                    aria-expanded="false"
                    aria-haspopup="true"
                    className="btn btn-primary btn-sm outline-drop font-weight-bold pl-3 pr-3 dropdown-toggle"
                    data-toggle="dropdown"
                    id="dropdownMenuButton"
                    type="button"
                >
                    {dropdownLabel}
                </button>
                <div aria-labelledby="dropdownMenuButton" className="dropdown-menu">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default ActionButtonWithDropdownItems;
